import { Injectable } from '@angular/core';
import { HttpService } from './HttpService';
import { IntermediaryDto } from '../model/business/IntermediaryDto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IntermediaryService {
  constructor(
    private httpService: HttpService
  ) { }

  getIntermediary(): Observable<IntermediaryDto> {
    return this.httpService.get('intermediary');
  }

  getIntermediaryById(intermediaryId: string): Observable<IntermediaryDto> {
    return this.httpService.get(`intermediary/${intermediaryId}`);
  }
}